export const ABOUT_PAGE_URL = "/about";
export const ACCOUNT_PAGE_URL = "/account";
export const APPOINTMENTS_PAGE_URL = "/appointments";
export const BOOKING_PAGE_URL = "/booking";
export const CONTACT_PAGE_URL = "/contact";
export const EVENT_PAGE_URL = "/events";
export const GALLERY_PAGE_URL = "/gallery";
export const HOME_PAGE_URL = "/";
export const INVOICES_PAGE_URL = "/invoices";
export const PRIVACY_POLICY_PAGE_URL = "/privacy-policy";
export const PROFILE_PAGE_URL = "/profile";
export const RESERVATIONS_PAGE_URL = "/reservations";
export const REVIEWS_PAGE_URL = "/reviews";
export const SERVICES_PAGE_URL = "/services";
export const SETTING_PAGE_URL = "/settings";
export const TERMS_OF_SERVICE_PAGE_URL = "/terms-of-service";

const PagesEndPoints = {
  ABOUT_PAGE_URL,
  ACCOUNT_PAGE_URL,
  APPOINTMENTS_PAGE_URL,
  BOOKING_PAGE_URL,
  CONTACT_PAGE_URL,
  EVENT_PAGE_URL,
  GALLERY_PAGE_URL,
  HOME_PAGE_URL,
  INVOICES_PAGE_URL,
  PRIVACY_POLICY_PAGE_URL,
  PROFILE_PAGE_URL,
  RESERVATIONS_PAGE_URL,
  REVIEWS_PAGE_URL,
  SERVICES_PAGE_URL,
  SETTING_PAGE_URL,
  TERMS_OF_SERVICE_PAGE_URL,
};
export default PagesEndPoints;
